{
  "validation": {
    "title": "Valideringsfeil",
    "description": "Noen av opplysningene er ikke korrekte. Vennligst sjekk og rett opp feilene før du prøver igjen."
  },
  "server": {
    "title": "Serverfeil",
    "description": "Det oppstod en feil ved {{action}} av {{entity}}. Vennligst prøv igjen senere."
  }
}
